import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CURRENT_USER,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  UPDATE_CURRENT_USER,
  UPDATE_CURRENT_USER_SUCCESS,
  UPDATE_CURRENT_USER_FAILURE,
  LOGIN_FAILURE,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  VERIFY_USER_FAILURE,
  VERIFY_USER_SUCCESS,
  VERIFY_USER,
  FORGET_PASSWORD_FAILURE,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD,
} from "./actionTypes";

export const loginUser = (payload) => {
  return {
    type: LOGIN_USER,
    payload,
  };
};

export const loginSuccess = (payload) => {
  return {
    type: LOGIN_SUCCESS,
    payload,
  };
};

export const loginFailure = (payload) => {
  return {
    type: LOGIN_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const logoutUser = () => {
  return {
    type: LOGOUT_USER,
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
  };
};

export const logoutUserFailure = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
  };
};

// ===================================================
// ===================================================

export const getCurrentUser = () => {
  return {
    type: CURRENT_USER,
  };
};

export const getCurrentUserSuccess = (payload) => {
  return {
    type: CURRENT_USER_SUCCESS,
    payload,
  };
};

export const getCurrentUserFailure = (payload) => {
  return {
    type: CURRENT_USER_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

// ===================================================
// ===================================================

export const updateCurrentUser = (payload) => {
  return {
    type: UPDATE_CURRENT_USER,
    payload,
  };
};

export const updateCurrentUserSuccess = (payload) => {
  return {
    type: UPDATE_CURRENT_USER_SUCCESS,
    payload,
  };
};

export const updateCurrentUserFailure = (payload) => {
  return {
    type: UPDATE_CURRENT_USER_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const updatePassword = (payload) => {
  return {
    type: UPDATE_PASSWORD,
    payload,
  };
};

export const updatePasswordSuccess = (payload) => {
  return {
    type: UPDATE_PASSWORD_SUCCESS,
    payload,
  };
};

export const updatePasswordFailure = (payload) => {
  return {
    type: UPDATE_PASSWORD_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const forgetPassword = (payload) => {
  return {
    type: FORGET_PASSWORD,
    payload,
  };
};

export const forgetPasswordSuccess = (payload) => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload,
  };
};

export const forgetPasswordFailure = (payload) => {
  return {
    type: FORGET_PASSWORD_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const verifyUser = (payload) => {
  return {
    type: VERIFY_USER,
    payload,
  };
};

export const verifyUserSuccess = (payload) => {
  return {
    type: VERIFY_USER_SUCCESS,
    payload,
  };
};

export const verifyUserFailure = (payload) => {
  return {
    type: VERIFY_USER_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
